import { DataBean } from "../DataBean";

export class ReleaseTransportGuide extends DataBean {

    public async releaseTransportGuideFromManifestCargo(idTransportGuide: any, transportGuideDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_releaseTransportGuideFromManifestCargo_Number_java.util.Date", [idTransportGuide, transportGuideDate]);
    }

}